import { Box, FlexProps, Flex, HStack } from "@chakra-ui/react";
import CDS from "design-system";
import InputEditButton from "components/Button/InputEditButton";
import ExternalLink from "components/Link";
import { PropsWithChildren } from "react";

interface InfoDisplayValueProps extends FlexProps {
  label: string;
  value?: string;
  toLink?: string;
  emptyDisplay?: string;
  openEdit?: () => void;
}

export function InfoDisplayValue({
  label,
  value = undefined,
  toLink = undefined,
  emptyDisplay = "None",
  openEdit = undefined,
  ...rest
}: InfoDisplayValueProps) {
  return (
    <Flex direction="column" my={2} {...rest}>
      {openEdit ? (
        <HStack>
          <Box color="chakra-subtle-text">{label}</Box>
          <InputEditButton onClick={openEdit} aria-label="Edit new hire onboarding plan" />
        </HStack>
      ) : (
        <Box color="chakra-subtle-text">{label}</Box>
      )}
      {toLink ? (
        <ExternalLink to={toLink} text={value ?? ""} />
      ) : (
        <CDS.Text14 {...(!value ? { as: "i" } : {})} whiteSpace="pre">
          {value || emptyDisplay}
        </CDS.Text14>
      )}
    </Flex>
  );
}

interface InfoColumnProps extends PropsWithChildren, FlexProps {
  header?: string;
}

export function InfoColumn({ children, header = undefined, ...rest }: InfoColumnProps) {
  return (
    <Flex direction="column" w="25%" h="80%" {...rest}>
      {header && (
        <Box borderBottom="2px solid" pb={2}>
          {header}
        </Box>
      )}
      {children}
    </Flex>
  );
}
